import React from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css"

export default function NavBar() {
    return (
       <div className="navBar">
        <nav>
            <NavLink to="/" className={"link"}>
                Home
            </NavLink>
            <NavLink to="/about" className={"link"}>
                About
            </NavLink>
            <NavLink to="/projects" className={"link"}>
                Projects
            </NavLink>
            <a href="https://github.com/LmCastelli" target="_blank" rel="noopener noreferrer" className={"link"}>GitHub</a>
            <a href="https://www.linkedin.com/in/lucas-castell/" target="_blank" rel="noopener noreferrer" className={"link"}>LinkedIn</a>
        </nav>
     </div>
    )
}